import { Card } from '@mui/material';
import { useEffect, useState } from 'react';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import Spinner from 'src/utils/Loader/spinner';
import { useToaster } from 'src/utils/toaster/toasterContext';
import PendingApprovalGrid from './pending-approval-grid.component';

const PendingApproval = ({ isOrgEvent,isShowOfferBanner=false  }) => {
  const [loader, setLoader] = useState(true);
  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();
  const [pendingApprovalData, setPendingApprovalData] = useState([]);
  const { showToast } = useToaster();

  useEffect(() => {
    getPendingApprovals('scheduled_time', 'asc');
  }, [isOrgEvent]);
  const getPendingApprovals = (sortBy = '', sortOrder = '') => {
    setOrder(sortOrder);
    setOrderBy(sortBy);
    let getProps = {
      url: isOrgEvent
        ? userModuleURL.getOrgPendingApprovals + `?sort_by=${sortBy}&sort_order=${sortOrder}`
        : userModuleURL.getPendingApprovals + `?sort_by=${sortBy}&sort_order=${sortOrder}`,
      successCallback: getPendingApprovalSuccessCallback,
      failureCallback,
    };
    HttpServices.Get(getProps);
  };
  const getPendingApprovalSuccessCallback = (data, message) => {
    message && showToast(message, 's');
    let filteredData = data.filter((data) => data.connected_profile_details?.length > 0);
    setPendingApprovalData(filteredData);
    setLoader(false);
  };
  const failureCallback = (message) => {
    message && showToast(message, 'e');
    setLoader(false);
  };
  const handleReCallPendingApprovalPost = (sortBy = '', sortOrder = '') => {
    setLoader(true);
    getPendingApprovals(sortBy, sortOrder);
  };
  return (
    <>
      {loader ? (
        <Spinner />
      ) : (
        <Card>
          <PendingApprovalGrid
            pendingApprovalList={pendingApprovalData}
            orderBy={orderBy}
            order={order}
            isOrgEvent={isOrgEvent}
            handleReCallPendingApprovalPost={handleReCallPendingApprovalPost}
            isShowOfferBanner={isShowOfferBanner}
          />
        </Card>
      )}
    </>
  );
};
export default PendingApproval;
